<div>
    <h4 class="h4 s1-s s1-m col-1 m-b-3 m-b-1-s m-b-1-m">{{title}}</h4>
    <div class="pos-relative">
        <button type="button"
                (click)="toggle()"
                style="border-radius: 12px;"
                class="w-12 p-a bg-col-w col-1 b-a b-col-5 s1 left"
                [toggleClass]="'_shadow'"
                [toggleClassBy]="openState.value">
            <span class="w-12 flex flex-justify-between">{{dropdownTitle}}
                <i class="_icon flex"
                   style="font-size: 20px;"
                   [toggleClass]="'icon-chevron-up !icon-chevron-down'"
                   [toggleClassBy]="openState.value"></i></span></button>
        <div class="pos-absolute left-0 right-0 z-3"
             [toggleClass]="'_dropdown-shadow'"
             [toggleClassBy]="openState.value"
             style="top: 85%; border-bottom-left-radius: 12px; border-bottom-right-radius: 12px;">
            <hide-up [open]="openState">
                <div class="bg-col-w b-col-5 b-b b-l b-r p-a-2"
                     style="border-bottom-left-radius: 12px; border-bottom-right-radius: 12px;">
                    <div [grid]="1"
                         [gridRowGap]="'16px'"
                         class="custom-scrollbar"
                         style="max-height: 378px; height: auto; overflow: auto;">
                        @for (option of filter.optionsWithCurrentMatches; track option.value) {
                        <div class="w-12 p-l-2"
                             [gridColumn]="1">
                            <button type="button"
                                    class="w-12 flex flex-middle"
                                    (click)="filter.toggle(option)"><i class="flex"
                                   [class]="filter.isSelected(option) ? 'icon-checkbox-checked' : 'icon-checkbox'"></i><span
                                      class="p1 m-l-3">{{option.label}}</span></button>
                        </div>
                        }
                    </div>
                </div>
            </hide-up>
        </div>
    </div>
</div>